import axios from 'axios';
import get from 'lodash/get';
import React, { useEffect, useState } from 'react';

export function VersionInfo() {
  const [versionInfo, setVersionInfo] = useState({
    gitHash: 'loading...',
    build: 'loading...',
  });

  useEffect(() => {
    const getVersionInfo = async () => {
      const response = await axios.get('/version-info.json');
      setVersionInfo(get(response, 'data', {}));
    };
    getVersionInfo();
  }, []);

  return (
    <div className="m-3">
      <h1 tabIndex={0}>Precert Enhancement Version</h1>
      <div>
        <span className="fw-bold">Version:</span> {import.meta.env.VITE_VERSION}
      </div>
      <div>
        <span className="fw-bold">Git:</span> {versionInfo.gitHash}
      </div>
      <div>
        <span className="fw-bold">Build:</span> {versionInfo.build}
      </div>
    </div>
  );
}
